// extracted by mini-css-extract-plugin
export var indeterminate = "_5i-5";
export var md = "_5i-4";
export var semantic = "_5i-6";
export var sm = "_5i-3";
export var text = "_5i-7";
export var toggleInput = "_5i-0";
export var toggleSwitch = "_5i-1";
export var xs = "_5i-2";